import {Text} from '@rdcomponents/text/text';
import {ReactElement} from 'react';

import {useLocale} from '../../../../../../../provider/locale/locale-hook';
import {LangKeyType} from '../../../../../../../provider/locale/translation/type';
import {ProvidersIdsEnum} from '../../../../../../../util/type';

type ConstraintsImageType = {
    minResolution: string;
    maxResolution: string;
    minSize: LangKeyType;
    maxSize: LangKeyType;
    formats: Array<string>;
    extra?: LangKeyType;
};

const CATALOG_IMAGE_CONSTRAINTS: Partial<Record<ProvidersIdsEnum, ConstraintsImageType>> = {
    [ProvidersIdsEnum.yandex]: {
        minResolution: '720×720',
        maxResolution: '3000×3000',
        minSize: 'COMPANY_FORM__GALLERY__HINT__MIN_SIZE',
        maxSize: 'COMPANY_FORM__GALLERY__HINT__MAX_SIZE',
        formats: ['.jpg', '.jpeg', '.png'],
    },
    [ProvidersIdsEnum.google]: {
        minResolution: '720×720',
        maxResolution: '3000×3000',
        minSize: 'COMPANY_FORM__GALLERY__HINT__MIN_SIZE',
        maxSize: 'COMPANY_FORM__GALLERY__HINT__MAX_SIZE__GOOGLE',
        formats: ['.jpg', '.jpeg', '.png'],
    },
    [ProvidersIdsEnum.doubleGis]: {
        minResolution: '600×600',
        maxResolution: '7000×7000',
        minSize: 'COMPANY_FORM__GALLERY__HINT__MIN_SIZE',
        maxSize: 'COMPANY_FORM__GALLERY__HINT__MAX_SIZE',
        formats: ['.jpg', '.jpeg'],
        extra: 'COMPANY_FORM__GALLERY__HINT__2GIS__PROPORTIONS',
    },
};

type PropsType = {
    catalogId: ProvidersIdsEnum;
    type: 'photo' | 'video';
};

export function UploadCompanyFormDescription(props: PropsType): ReactElement {
    const {catalogId, type} = props;
    const {getLocalizedString} = useLocale();
    const cfg = CATALOG_IMAGE_CONSTRAINTS[catalogId];

    const photoReplacements: Record<string, string> = {
        minResolution: cfg?.minResolution || '720×720',
        maxResolution: cfg?.maxResolution || '3000×3000',
        minSize: getLocalizedString(cfg?.minSize || 'COMPANY_FORM__GALLERY__HINT__MIN_SIZE'),
        maxSize: getLocalizedString(cfg?.maxSize || 'COMPANY_FORM__GALLERY__HINT__MAX_SIZE'),
        formats: cfg?.formats.join(' ') || '.jpg .jpeg .png',
        extra: cfg?.extra ? `\n${getLocalizedString(cfg.extra)}` : '',
    };

    if (type === 'photo') {
        return (
            <Text
                secondary
                small
                stringKey="COMPANY_FORM__UPLOAD_PHOTO_BUTTON__DESCRIPTION"
                valueMap={photoReplacements}
            />
        );
    }

    return <Text secondary small stringKey="COMPANY_FORM__UPLOAD_VIDEO_BUTTON__DESCRIPTION" />;
}
